import { EventEmitter } from "events";

import Dispatcher from "./dispatcher";
import Constants from "./constants";
import sideBarUserItems from "../data/sidebar-nav-items";

let _store = {
  menuVisible: false,
  navItems: sideBarUserItems()
};

class Store extends EventEmitter {
  constructor() {
    super();

    this.registerToActions = this.registerToActions.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.toggleSidebarDropdown = this.toggleSidebarDropdown.bind(this);

    Dispatcher.register(this.registerToActions.bind(this));
  }

  registerToActions({ actionType, payload }) {
    switch (actionType) {
      case Constants.TOGGLE_SIDEBAR:
        this.toggleSidebar();
        break;
      case Constants.TOGGLE_SIDEBAR_DROPDOWN:
        this.toggleSidebarDropdown(payload);
        break;
      default:
    }
  }

  toggleSidebar() {
    _store.menuVisible = !_store.menuVisible;
    this.emit(Constants.CHANGE);
  }

  toggleSidebarDropdown(item) {
    const newStore = { ..._store };

    let navGroupIdx = null;
    let navItemIdx = null;

    newStore.navItems.forEach((navItem, _idx) => {
      const __idx = navItem.items.indexOf(item);
      if (__idx !== -1) {
        navGroupIdx = _idx;
        navItemIdx = __idx;
      }
    });

    newStore.navItems[navGroupIdx].items[navItemIdx].open = !newStore.navItems[
      navGroupIdx
    ].items[navItemIdx].open;

    newStore.navItems = newStore.navItems.map(i => {
      i.items = i.items.map((_i, idx) => {
        if (idx !== navItemIdx) {
          _i.open = false;
        }
        return _i;
      });
      return i;
    });

    _store = newStore;
    this.emit(Constants.CHANGE);
  }

  getMenuState() {
    return _store.menuVisible;
  }

  getFileteredSideBarItems() {
    const user_roles = JSON.parse(localStorage.getItem("userRoles"));
    if (!user_roles) return [];
    const items = _store.navItems;
    let filtered_items = [];
    items.forEach(i => {
      if (
        !i.roles ||
        i.roles.length === 0 ||
        i.roles.some(role =>
          user_roles.some(userRole => userRole.name === role)
        )
      ) {
        if (
          i &&
          i.items &&
          i.items[0] &&
          i.items[0].items &&
          i.items[0].items.length > 0
        ) {
          i.items[0].items = i.items[0].items.filter(
            item =>
              !item.exact ||
              item.exact.length == 0 ||
              item.exact.some(role =>
                user_roles.some(userRole => userRole.name === role)
              )
          );
          filtered_items.push(i);
        }
      }
    });
    return filtered_items;
  }

  getSidebarItems() {
    // TODO gilter navItems by profile by token o get menu and urls
    return this.getFileteredSideBarItems();
  }

  addChangeListener(callback) {
    this.on(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new Store();
